/**
 * Basketball Dress Builder - Custom Product Designer
 * 实时预览和定制功能
 * Version: 2026-01-06 with Letter Spacing and Stroke Toggle
 */

console.log('Basketball Dress Builder v2026-01-06 loaded - Letter Spacing + Stroke Toggle enabled');

class BasketballDressBuilder {
  constructor() {
    console.log('BasketballDressBuilder constructor called');
    
    this.canvas = document.getElementById('dress-preview-canvas');
    if (!this.canvas) {
      console.error('Canvas element not found!');
      return;
    }
    
    console.log('Canvas found:', this.canvas);
    
    this.ctx = this.canvas.getContext('2d');
    this.currentView = 'front';
    this.zoomLevel = 1.4;
    
    // 模板图片
    this.templateImages = {
      front: null,
      back: null
    };
    
    // 装饰层图片（领子、袖口等）
    this.trimImages = {
      front: null,
      back: null
    };
    
    // 定制数据
    this.customization = {
      size: '',
      primaryColor: '#E31837', // 默认红色
      secondaryColor: '#FFFFFF', // 默认白色
      playerNumberFront: '',
      playerNumberBack: '',
      playerName: '',
      teamName: '',
      logoImage: null,
      // Logo位置和缩放
      logoPositionX: 0,
      logoPositionY: -100,
      logoScale: 1.0, // 缩放比例 (0.5 - 3.0)
      // 队名样式
        teamFont: 'Impact',
        teamSize: 26,
      teamFillColor: '#FFFFFF',
      teamStrokeColor: '#E31837',
      teamPositionX: -100,
      teamPositionY: -130,
      teamCurve: 0,
      teamLetterSpacing: 0, // 字符间距
      teamStrokeEnabled: true, // 描边开关
      teamLastStrokeColor: '#E31837', // 记录上次点击的描边颜色
      // 前面号码样式
      numberFrontFont: 'Impact',
      numberFrontSize: 80,
      numberFrontFillColor: '#FFFFFF',
      numberFrontStrokeColor: '#000000',
      numberFrontPositionY: -60,
      numberFrontPositionX: -100,
      numberFrontLetterSpacing: 5, // 字符间距
      numberFrontStrokeEnabled: true, // 描边开关
      numberFrontLastStrokeColor: '#000000', // 记录上次点击的描边颜色
      // 背面号码样式
      numberBackFont: 'Impact',
        numberBackSize: 80,
        numberBackFillColor: '#FFFFFF',
        numberBackStrokeColor: '#000000',
        // align back-number starting position with front-number by default
        numberBackPositionY: -60,
          numberBackPositionX: -100,
      numberBackLetterSpacing: 5, // 字符间距
      // 名字样式
      nameFont: 'Arial',
        nameSize: 28,
      nameFillColor: '#FFFFFF',
      nameStrokeColor: '#E31837',
          // separate defaults for front/back name positions
          nameFrontPositionY: -130,
          nameFrontPositionX: 100,
          nameBackPositionY: -130,
          nameBackPositionX: 0,
      // legacy single-position kept for compatibility
      namePositionY: 100,
      namePositionX: 0,
      nameCurve: 0 // 弧形程度 -100 到 100
    };
    
    // 价格数据
    this.pricing = window.basketballDressBuilderData || {
      basePrice: 59.99,
      customizationFee: 15.00,
      logoUploadFee: 10.00
    };

    // Team Order 数据
    this.teamPlayers = []; // 存储团队订单的球员信息
    this.isTeamOrder = false; // 是否是团队订单模式
    this.singleOrderQuantity = 1; // 单件订单数量
    
    this.init();

    // Set initial visible defaults so the UI shows them on page load
    try {
      const nf = document.getElementById('player-number-front');
      if (nf) {
        nf.value = '00';
        this.customization.playerNumberFront = nf.value;
      }

      const nb = document.getElementById('player-number-back');
      if (nb) {
        nb.value = '00';
        this.customization.playerNumberBack = nb.value;
      }

      const ni = document.getElementById('player-name');
      if (ni) {
        ni.value = 'your name';
        this.customization.playerName = ni.value;
      }

      const ti = document.getElementById('team-name');
      if (ti) {
        ti.value = 'team name';
        this.customization.teamName = ti.value;
      }

      // Ensure back-number defaults align with the player name's initial position (centered), but remain independent after dragging
      this.customization.numberBackPositionX = ((this.customization.nameBackPositionX !== undefined && this.customization.nameBackPositionX !== null)
        ? this.customization.nameBackPositionX
        : (this.customization.namePositionX || 0)) + 100;
      // Ensure back number initial Y exactly matches back player name initial Y, then shift down 70px
      this.customization.numberBackPositionY = ((this.customization.nameBackPositionY !== undefined && this.customization.nameBackPositionY !== null)
        ? this.customization.nameBackPositionY
        : (this.customization.namePositionY || 0)) + 70;

      // Ensure preview reflects the defaults immediately
      this.drawPreview();
    } catch (e) {
      console.warn('Could not set initial default inputs:', e);
    }
  }
  
  init() {
    this.loadTemplateImages();
    this.setupEventListeners();
    // disable the manual position inputs (we will use canvas dragging instead)
    this.disablePositionInputs();
    this.enableCanvasDragging();
    this.updatePricing();
  }

  // Hide/disable the position X/Y inputs since dragging on canvas is the canonical control
  disablePositionInputs() {
    const ids = [
      'team-position-x','team-position-y',
      'name-position-x','name-position-y',
      'number-front-position-x','number-front-position-y',
      'number-back-position-x','number-back-position-y'
    ];
    ids.forEach(id => {
      const el = document.getElementById(id);
      if (el) {
        // try hiding the control row if present, otherwise hide the input itself
        const row = el.closest && el.closest('.control-row');
        if (row) row.style.display = 'none';
        else el.style.display = 'none';
        el.disabled = true;
      }
    });
  }
  
  loadTemplateImages() {
    const data = window.basketballDressBuilderData;
    
    // 加载前视图模板
    if (data && data.templateFront) {
      console.log('Loading front template:', data.templateFront);
      const frontImg = new Image();
      frontImg.crossOrigin = 'anonymous';
      frontImg.onload = () => {
        console.log('Front template loaded successfully');
        this.templateImages.front = frontImg;
        this.drawPreview();
      };
      frontImg.onerror = (e) => {
        console.error('Failed to load front template:', e);
        console.log('Falling back to default drawing');
        this.drawInitialPreview();
      };
      frontImg.src = data.templateFront;
    } else {
      console.log('No front template specified, using default drawing');
      // 如果没有模板，使用默认绘制
      this.drawInitialPreview();
    }
    
    // 加载背视图模板
    if (data && data.templateBack) {
      console.log('Loading back template:', data.templateBack);
      const backImg = new Image();
      backImg.crossOrigin = 'anonymous';
      backImg.onload = () => {
        console.log('Back template loaded successfully');
        this.templateImages.back = backImg;
      };
      backImg.onerror = (e) => {
        console.error('Failed to load back template:', e);
      };
      backImg.src = data.templateBack;
    }
    
    // 加载前视图装饰层（领子、袖口等）
    if (data && data.trimFront) {
      console.log('Loading front trim:', data.trimFront);
      const trimFrontImg = new Image();
      trimFrontImg.crossOrigin = 'anonymous';
      trimFrontImg.onload = () => {
        console.log('Front trim loaded successfully');
        this.trimImages.front = trimFrontImg;
        this.drawPreview();
      };
      trimFrontImg.onerror = (e) => {
        console.error('Failed to load front trim:', e);
      };
      trimFrontImg.src = data.trimFront;
    }
    
    // 加载背视图装饰层
    if (data && data.trimBack) {
      console.log('Loading back trim:', data.trimBack);
      const trimBackImg = new Image();
      trimBackImg.crossOrigin = 'anonymous';
      trimBackImg.onload = () => {
        console.log('Back trim loaded successfully');
        this.trimImages.back = trimBackImg;
        if (this.currentView === 'back') this.drawPreview();
      };
      trimBackImg.onerror = (e) => {
        console.error('Failed to load back trim:', e);
      };
      trimBackImg.src = data.trimBack;
    }
  }

  // 更新字体选择器的预览样式
  updateFontPreview(selectElement) {
    if (!selectElement) {
      console.warn('updateFontPreview: selectElement is null');
      return;
    }
    
    console.log('updateFontPreview called for:', selectElement.id, 'current value:', selectElement.value);
    
    // 移除所有字体类
    selectElement.classList.remove('font-impact', 'font-arial', 'font-bebas', 'font-anton', 'font-oswald', 
                           'font-team1', 'font-team2', 'font-team3', 'font-team4', 'font-team5', 'font-team6', 'font-team7');
    
    const value = selectElement.value;
    let appliedClass = 'none';
    
    // 根据选中的值添加对应的字体类
    if (value === 'Impact') {
      selectElement.classList.add('font-impact');
      appliedClass = 'font-impact';
    } else if (value === 'Arial') {
      selectElement.classList.add('font-arial');
      appliedClass = 'font-arial';
    } else if (value.includes('Bebas')) {
      selectElement.classList.add('font-bebas');
      appliedClass = 'font-bebas';
    } else if (value.includes('Anton')) {
      selectElement.classList.add('font-anton');
      appliedClass = 'font-anton';
    } else if (value.includes('Oswald')) {
      selectElement.classList.add('font-oswald');
      appliedClass = 'font-oswald';
    } else if (value.includes('Team1')) {
      selectElement.classList.add('font-team1');
      appliedClass = 'font-team1';
    } else if (value.includes('Team2')) {
      selectElement.classList.add('font-team2');
      appliedClass = 'font-team2';
    } else if (value.includes('Team3')) {
      selectElement.classList.add('font-team3');
      appliedClass = 'font-team3';
    } else if (value.includes('Team4')) {
      selectElement.classList.add('font-team4');
      appliedClass = 'font-team4';
    } else if (value.includes('Team5')) {
      selectElement.classList.add('font-team5');
      appliedClass = 'font-team5';
    } else if (value.includes('Team6')) {
      selectElement.classList.add('font-team6');
      appliedClass = 'font-team6';
    } else if (value.includes('Team7')) {
      selectElement.classList.add('font-team7');
      appliedClass = 'font-team7';
    }
    
    console.log('Applied font class:', appliedClass, 'Current classList:', Array.from(selectElement.classList));
  }
  
  setupEventListeners() {
    // 尺寸选择
    const sizeSelect = document.getElementById('dress-size');
    if (sizeSelect) {
      sizeSelect.addEventListener('change', (e) => {
        this.customization.size = e.target.value;
        this.updatePricing();
      });
    }

    // 数量选择
    const quantitySelect = document.getElementById('dress-quantity');
    if (quantitySelect) {
      quantitySelect.addEventListener('change', (e) => {
        this.singleOrderQuantity = parseInt(e.target.value) || 1;
        this.updatePricing();
      });
      quantitySelect.addEventListener('input', (e) => {
        this.singleOrderQuantity = parseInt(e.target.value) || 1;
        this.updatePricing();
      });
    }

    // 数量增加按钮
    const quantityIncrease = document.getElementById('quantity-increase');
    if (quantityIncrease) {
      quantityIncrease.addEventListener('click', () => {
        const input = document.getElementById('dress-quantity');
        if (input) {
          const currentValue = parseInt(input.value) || 1;
          const maxValue = parseInt(input.max) || 100;
          const newValue = Math.min(currentValue + 1, maxValue);
          input.value = newValue;
          this.singleOrderQuantity = newValue;
          this.updatePricing();
        }
      });
    }

    // 数量减少按钮
    const quantityDecrease = document.getElementById('quantity-decrease');
    if (quantityDecrease) {
      quantityDecrease.addEventListener('click', () => {
        const input = document.getElementById('dress-quantity');
        if (input) {
          const currentValue = parseInt(input.value) || 1;
          const minValue = parseInt(input.min) || 1;
          const newValue = Math.max(currentValue - 1, minValue);
          input.value = newValue;
          this.singleOrderQuantity = newValue;
          this.updatePricing();
        }
      });
    }
    
    // 主体颜色选择
    const primaryColors = document.querySelectorAll('.color-picker-grid:not(.secondary-colors) .color-option');
    primaryColors.forEach(option => {
      option.addEventListener('click', () => {
        primaryColors.forEach(opt => opt.classList.remove('selected'));
        option.classList.add('selected');
        this.customization.primaryColor = option.dataset.color;
        document.getElementById('primary-color').value = option.dataset.color;
        this.drawPreview();
      });
    });
    
    // 次要颜色选择
    const secondaryColors = document.querySelectorAll('.secondary-colors .color-option');
    secondaryColors.forEach(option => {
      option.addEventListener('click', () => {
        secondaryColors.forEach(opt => opt.classList.remove('selected'));
        option.classList.add('selected');
        this.customization.secondaryColor = option.dataset.color;
        document.getElementById('secondary-color').value = option.dataset.color;
        this.drawPreview();
      });
    });
    
    // 前面号码输入
    const numberFrontInput = document.getElementById('player-number-front');
    if (numberFrontInput) {
      // 初始化时同步值
      if (numberFrontInput.value) {
        this.customization.playerNumberFront = numberFrontInput.value;
      }
      numberFrontInput.addEventListener('input', (e) => {
        e.target.value = e.target.value.replace(/[^0-9]/g, '');
        this.customization.playerNumberFront = e.target.value;
        console.log('Front number input:', e.target.value, 'Customization:', this.customization.playerNumberFront);
        this.drawPreview();
        this.updatePricing();
      });
    }
    
    // 背面号码输入
    const numberBackInput = document.getElementById('player-number-back');
    if (numberBackInput) {
      // 初始化时同步值
      if (numberBackInput.value) {
        this.customization.playerNumberBack = numberBackInput.value;
      }
      numberBackInput.addEventListener('input', (e) => {
        e.target.value = e.target.value.replace(/[^0-9]/g, '');
        this.customization.playerNumberBack = e.target.value;
        this.drawPreview();
        this.updatePricing();
      });
    }
    
    // 名字输入
    const nameInput = document.getElementById('player-name');
    if (nameInput) {
      // 初始化时同步值
      if (nameInput.value) {
        this.customization.playerName = nameInput.value.toUpperCase();
      }
      nameInput.addEventListener('input', (e) => {
        this.customization.playerName = e.target.value.toUpperCase();
        this.drawPreview();
        this.updatePricing();
      });
    }
    
    // 队名输入
    const teamInput = document.getElementById('team-name');
    if (teamInput) {
      // 初始化时同步值
      if (teamInput.value) {
        this.customization.teamName = teamInput.value.toUpperCase();
      }
      teamInput.addEventListener('input', (e) => {
        this.customization.teamName = e.target.value.toUpperCase();
        this.drawPreview();
        this.updatePricing();
      });
    }
    
    // Logo上传
    const logoInput = document.getElementById('team-logo');
    if (logoInput) {
      logoInput.addEventListener('change', (e) => {
        const file = e.target.files[0];
        if (file) {
          const reader = new FileReader();
          reader.onload = (event) => {
            const img = new Image();
            img.onload = () => {
              this.customization.logoImage = img;
              this.drawPreview();
              this.updatePricing();
            };
            img.src = event.target.result;
          };
          reader.readAsDataURL(file);
          
          // 显示文件名
          const fileName = document.querySelector('.file-name');
          if (fileName) {
            fileName.textContent = file.name;
          }
          
          // 显示 logo 缩放控制
          const logoScaleControl = document.getElementById('logo-scale-control');
          if (logoScaleControl) {
            logoScaleControl.style.display = 'block';
          }
        }
      });
    }
    
    // Logo 缩放控制
    const logoScaleInput = document.getElementById('logo-scale');
    const logoScaleValue = document.getElementById('logo-scale-value');
    if (logoScaleInput && logoScaleValue) {
      logoScaleInput.addEventListener('input', (e) => {
        const scale = parseFloat(e.target.value);
        this.customization.logoScale = scale;
        logoScaleValue.textContent = scale.toFixed(1) + 'x';
        this.drawPreview();
      });
    }
    
    // 视角切换
    const viewButtons = document.querySelectorAll('.view-btn');
    viewButtons.forEach(btn => {
      btn.addEventListener('click', () => {
        viewButtons.forEach(b => b.classList.remove('active'));
        btn.classList.add('active');
        this.currentView = btn.dataset.view;
        this.drawPreview();
      });
    });
    
    // 缩放控制
    const zoomIn = document.getElementById('zoom-in');
    const zoomOut = document.getElementById('zoom-out');
    const zoomReset = document.getElementById('zoom-reset');
    
    if (zoomIn) {
      zoomIn.addEventListener('click', () => {
        this.zoomLevel = Math.min(this.zoomLevel + 0.1, 2);
        this.drawPreview();
      });
    }
    
    if (zoomOut) {
      zoomOut.addEventListener('click', () => {
        this.zoomLevel = Math.max(this.zoomLevel - 0.1, 0.5);
        this.drawPreview();
      });
    }
    
    if (zoomReset) {
      zoomReset.addEventListener('click', () => {
        this.zoomLevel = 1;
        this.drawPreview();
      });
    }

    // (removed temporary dblclick toggle) 双击切换已移除 — 使用页面上的视图按钮
    
    // 表单提交（添加到购物车）
    const form = document.getElementById('dress-builder-form');
    if (form) {
      form.addEventListener('submit', (e) => {
        e.preventDefault();
        this.addToCart();
      });
    }
    
    // 号码样式控制
    this.setupTextStyleControls();
    
    // 折叠/展开样式控制
    this.setupToggleButtons();
  }
  
  setupToggleButtons() {
    // 队名样式折叠/展开
    const toggleTeamBtn = document.getElementById('toggle-team-styling');
    const teamOptions = document.getElementById('team-styling-options');
    if (toggleTeamBtn && teamOptions) {
      toggleTeamBtn.addEventListener('click', () => {
        const isHidden = teamOptions.style.display === 'none';
        teamOptions.style.display = isHidden ? 'block' : 'none';
        toggleTeamBtn.textContent = isHidden ? '−' : '+';
        toggleTeamBtn.classList.toggle('active', isHidden);
      });
    }
    
    // 前面号码样式折叠/展开
    const toggleNumberFrontBtn = document.getElementById('toggle-number-front-styling');
    const numberFrontOptions = document.getElementById('number-front-styling-options');
    if (toggleNumberFrontBtn && numberFrontOptions) {
      toggleNumberFrontBtn.addEventListener('click', () => {
        const isHidden = numberFrontOptions.style.display === 'none';
        numberFrontOptions.style.display = isHidden ? 'block' : 'none';
        toggleNumberFrontBtn.textContent = isHidden ? '−' : '+';
        toggleNumberFrontBtn.classList.toggle('active', isHidden);
      });
    }
    
    // 背面号码样式折叠/展开
    const toggleNumberBackBtn = document.getElementById('toggle-number-back-styling');
    const numberBackOptions = document.getElementById('number-back-styling-options');
    if (toggleNumberBackBtn && numberBackOptions) {
      toggleNumberBackBtn.addEventListener('click', () => {
        const isHidden = numberBackOptions.style.display === 'none';
        numberBackOptions.style.display = isHidden ? 'block' : 'none';
        toggleNumberBackBtn.textContent = isHidden ? '−' : '+';
        toggleNumberBackBtn.classList.toggle('active', isHidden);
      });
    }
    
    // 名字样式折叠/展开
    const toggleNameBtn = document.getElementById('toggle-name-styling');
    const nameOptions = document.getElementById('name-styling-options');
    if (toggleNameBtn && nameOptions) {
      toggleNameBtn.addEventListener('click', () => {
        const isHidden = nameOptions.style.display === 'none';
        nameOptions.style.display = isHidden ? 'block' : 'none';
        toggleNameBtn.textContent = isHidden ? '−' : '+';
        toggleNameBtn.classList.toggle('active', isHidden);
      });
    }
  }
  
  setupTextStyleControls() {
    // ========== 队名样式控制 ==========
    // 字体大小
    const teamSize = document.getElementById('team-size');
    const teamSizeValue = document.getElementById('team-size-value');
    if (teamSize) {
      teamSize.addEventListener('input', (e) => {
        this.customization.teamSize = parseInt(e.target.value);
        if (teamSizeValue) teamSizeValue.textContent = e.target.value + 'px';
        this.drawPreview();
      });
    }
    
    // 位置Y
    const teamPosY = document.getElementById('team-position-y');
    const teamPosYValue = document.getElementById('team-position-y-value');
    if (teamPosY) {
      teamPosY.addEventListener('input', (e) => {
        this.customization.teamPositionY = parseInt(e.target.value);
        if (teamPosYValue) teamPosYValue.textContent = e.target.value;
        this.drawPreview();
      });
    }
    
    // 字符间距
    const teamLetterSpacing = document.getElementById('team-letter-spacing');
    const teamLetterSpacingValue = document.getElementById('team-letter-spacing-value');
    if (teamLetterSpacing) {
      teamLetterSpacing.addEventListener('input', (e) => {
        this.customization.teamLetterSpacing = parseInt(e.target.value);
        if (teamLetterSpacingValue) teamLetterSpacingValue.textContent = e.target.value + 'px';
        console.log('Team letter spacing changed to:', e.target.value);
        this.drawPreview();
      });
    }

    // 位置X
    const teamPosX = document.getElementById('team-position-x');
    const teamPosXValue = document.getElementById('team-position-x-value');
    if (teamPosX) {
      teamPosX.addEventListener('input', (e) => {
        this.customization.teamPositionX = parseInt(e.target.value);
        if (teamPosXValue) teamPosXValue.textContent = e.target.value;
        this.drawPreview();
      });
    }
    
    // 字体
    const teamFont = document.getElementById('team-font');
    if (teamFont) {
      // 初始化字体预览
      this.updateFontPreview(teamFont);
      
      teamFont.addEventListener('change', (e) => {
        this.customization.teamFont = e.target.value;
        this.updateFontPreview(teamFont);
        this.drawPreview();
      });
    }
    
    // 填充颜色
    const teamFillColors = document.querySelectorAll('#team-fill-colors .mini-color-swatch');
    teamFillColors.forEach(swatch => {
      swatch.addEventListener('click', () => {
        teamFillColors.forEach(s => s.classList.remove('selected'));
        swatch.classList.add('selected');
        this.customization.teamFillColor = swatch.dataset.color;
        this.drawPreview();
      });
    });
    const defaultTeamFill = Array.from(teamFillColors).find(s => s.dataset.color === '#FFFFFF');
    if (defaultTeamFill) defaultTeamFill.classList.add('selected');
    
    // 描边颜色（点击2次取消）
    const teamStrokeColors = document.querySelectorAll('#team-stroke-colors .mini-color-swatch');
    teamStrokeColors.forEach(swatch => {
      swatch.addEventListener('click', () => {
        const clickedColor = swatch.dataset.color;
        
        // 如果点击的是上次选中的颜色，则取消描边
        if (this.customization.teamStrokeEnabled && clickedColor === this.customization.teamLastStrokeColor) {
          this.customization.teamStrokeEnabled = false;
          teamStrokeColors.forEach(s => s.classList.remove('selected'));
        } else {
          // 否则选中新颜色并启用描边
          teamStrokeColors.forEach(s => s.classList.remove('selected'));
          swatch.classList.add('selected');
          this.customization.teamStrokeColor = clickedColor;
          this.customization.teamLastStrokeColor = clickedColor;
          this.customization.teamStrokeEnabled = true;
        }
        
        this.drawPreview();
      });
    });
    const defaultTeamStroke = Array.from(teamStrokeColors).find(s => s.dataset.color === '#E31837');
    if (defaultTeamStroke) defaultTeamStroke.classList.add('selected');

    // 队名弧形（Curve）
    const teamCurve = document.getElementById('team-curve');
    const teamCurveValue = document.getElementById('team-curve-value');
    if (teamCurve) {
      teamCurve.addEventListener('input', (e) => {
        this.customization.teamCurve = parseInt(e.target.value);
        if (teamCurveValue) teamCurveValue.textContent = e.target.value;
        this.drawPreview();
      });
    }
    
    // ========== 前面号码样式控制 ==========
    // 字体大小
    const numberFrontSize = document.getElementById('number-front-size');
    const numberFrontSizeValue = document.getElementById('number-front-size-value');
    if (numberFrontSize) {
      numberFrontSize.addEventListener('input', (e) => {
        this.customization.numberFrontSize = parseInt(e.target.value);
        // Keep back number size in sync with front number size
        this.customization.numberBackSize = this.customization.numberFrontSize;
        const nbInput = document.getElementById('number-back-size');
        const nbValue = document.getElementById('number-back-size-value');
        if (nbInput) nbInput.value = e.target.value;
        if (nbValue) nbValue.textContent = e.target.value + 'px';
        if (numberFrontSizeValue) numberFrontSizeValue.textContent = e.target.value + 'px';
        this.drawPreview();
      });
    }
    
    // 位置Y
    const numberFrontPosY = document.getElementById('number-front-position-y');
    const numberFrontPosYValue = document.getElementById('number-front-position-y-value');
    if (numberFrontPosY) {
      numberFrontPosY.addEventListener('input', (e) => {
        this.customization.numberFrontPositionY = parseInt(e.target.value);
        if (numberFrontPosYValue) numberFrontPosYValue.textContent = e.target.value;
        this.drawPreview();
      });
    }

    // 前面号码位置X
    const numberFrontPosX = document.getElementById('number-front-position-x');
    const numberFrontPosXValue = document.getElementById('number-front-position-x-value');
    if (numberFrontPosX) {
      numberFrontPosX.addEventListener('input', (e) => {
        this.customization.numberFrontPositionX = parseInt(e.target.value);
        if (numberFrontPosXValue) numberFrontPosXValue.textContent = e.target.value;
        this.drawPreview();
      });
    }
    
    // 字符间距
    const numberFrontLetterSpacing = document.getElementById('number-front-letter-spacing');
    const numberFrontLetterSpacingValue = document.getElementById('number-front-letter-spacing-value');
    if (numberFrontLetterSpacing) {
      numberFrontLetterSpacing.addEventListener('input', (e) => {
        this.customization.numberFrontLetterSpacing = parseInt(e.target.value);
        console.log('Number front letter spacing changed to:', e.target.value);
        if (numberFrontLetterSpacingValue) numberFrontLetterSpacingValue.textContent = e.target.value + 'px';
        this.drawPreview();
      });
    }
    
    // 字体
    const numberFrontFont = document.getElementById('number-front-font');
    if (numberFrontFont) {
      // 初始化字体预览
      this.updateFontPreview(numberFrontFont);
      
      numberFrontFont.addEventListener('change', (e) => {
        this.customization.numberFrontFont = e.target.value;
        this.updateFontPreview(numberFrontFont);
        this.drawPreview();
      });
    }
    
    // 填充颜色
    const numberFrontFillColors = document.querySelectorAll('#number-front-fill-colors .mini-color-swatch');
    numberFrontFillColors.forEach(swatch => {
      swatch.addEventListener('click', () => {
        numberFrontFillColors.forEach(s => s.classList.remove('selected'));
        swatch.classList.add('selected');
        this.customization.numberFrontFillColor = swatch.dataset.color;
        this.drawPreview();
      });
    });
    const defaultNumberFrontFill = Array.from(numberFrontFillColors).find(s => s.dataset.color === '#FFFFFF');
    if (defaultNumberFrontFill) defaultNumberFrontFill.classList.add('selected');
    
    // 描边颜色（点击2次取消）
    const numberFrontStrokeColors = document.querySelectorAll('#number-front-stroke-colors .mini-color-swatch');
    numberFrontStrokeColors.forEach(swatch => {
      swatch.addEventListener('click', () => {
        const clickedColor = swatch.dataset.color;
        
        // 如果点击的是上次选中的颜色，则取消描边
        if (this.customization.numberFrontStrokeEnabled && clickedColor === this.customization.numberFrontLastStrokeColor) {
          this.customization.numberFrontStrokeEnabled = false;
          numberFrontStrokeColors.forEach(s => s.classList.remove('selected'));
        } else {
          // 否则选中新颜色并启用描边
          numberFrontStrokeColors.forEach(s => s.classList.remove('selected'));
          swatch.classList.add('selected');
          this.customization.numberFrontStrokeColor = clickedColor;
          this.customization.numberFrontLastStrokeColor = clickedColor;
          this.customization.numberFrontStrokeEnabled = true;
        }
        
        this.drawPreview();
      });
    });
    const defaultNumberFrontStroke = Array.from(numberFrontStrokeColors).find(s => s.dataset.color === '#000000');
    if (defaultNumberFrontStroke) defaultNumberFrontStroke.classList.add('selected');
    
    // ========== 背面号码样式控制 ==========
    // 字体大小
    const numberBackSize = document.getElementById('number-back-size');
    const numberBackSizeValue = document.getElementById('number-back-size-value');
    if (numberBackSize) {
      numberBackSize.addEventListener('input', (e) => {
        this.customization.numberBackSize = parseInt(e.target.value);
        if (numberBackSizeValue) numberBackSizeValue.textContent = e.target.value + 'px';
        this.drawPreview();
      });
    }
    
    // 位置Y
    const numberBackPosY = document.getElementById('number-back-position-y');
    const numberBackPosYValue = document.getElementById('number-back-position-y-value');
    if (numberBackPosY) {
      numberBackPosY.addEventListener('input', (e) => {
        this.customization.numberBackPositionY = parseInt(e.target.value);
        if (numberBackPosYValue) numberBackPosYValue.textContent = e.target.value;
        this.drawPreview();
      });
    }

    // 背面号码位置X
    const numberBackPosX = document.getElementById('number-back-position-x');
    const numberBackPosXValue = document.getElementById('number-back-position-x-value');
    if (numberBackPosX) {
      numberBackPosX.addEventListener('input', (e) => {
        this.customization.numberBackPositionX = parseInt(e.target.value);
        if (numberBackPosXValue) numberBackPosXValue.textContent = e.target.value;
        this.drawPreview();
      });
    }
    
    // 字母间距
    const numberBackLetterSpacing = document.getElementById('number-back-letter-spacing');
    const numberBackLetterSpacingValue = document.getElementById('number-back-letter-spacing-value');
    if (numberBackLetterSpacing) {
      numberBackLetterSpacing.addEventListener('input', (e) => {
        this.customization.numberBackLetterSpacing = parseInt(e.target.value);
        if (numberBackLetterSpacingValue) numberBackLetterSpacingValue.textContent = e.target.value + 'px';
        this.drawPreview();
      });
    }
    
    // 字体
    const numberBackFont = document.getElementById('number-back-font');
    if (numberBackFont) {
      // 初始化字体预览
      this.updateFontPreview(numberBackFont);
      
      numberBackFont.addEventListener('change', (e) => {
        this.customization.numberBackFont = e.target.value;
        this.updateFontPreview(numberBackFont);
        this.drawPreview();
      });
    }
    
    // 填充颜色
    const numberBackFillColors = document.querySelectorAll('#number-back-fill-colors .mini-color-swatch');
    numberBackFillColors.forEach(swatch => {
      swatch.addEventListener('click', () => {
        numberBackFillColors.forEach(s => s.classList.remove('selected'));
        swatch.classList.add('selected');
        this.customization.numberBackFillColor = swatch.dataset.color;
        this.drawPreview();
      });
    });
    const defaultNumberBackFill = Array.from(numberBackFillColors).find(s => s.dataset.color === '#FFFFFF');
    if (defaultNumberBackFill) defaultNumberBackFill.classList.add('selected');
    
    // 描边颜色
    const numberBackStrokeColors = document.querySelectorAll('#number-back-stroke-colors .mini-color-swatch');
    numberBackStrokeColors.forEach(swatch => {
      swatch.addEventListener('click', () => {
        numberBackStrokeColors.forEach(s => s.classList.remove('selected'));
        swatch.classList.add('selected');
        this.customization.numberBackStrokeColor = swatch.dataset.color;
        this.drawPreview();
      });
    });
    const defaultNumberBackStroke = Array.from(numberBackStrokeColors).find(s => s.dataset.color === '#000000');
    if (defaultNumberBackStroke) defaultNumberBackStroke.classList.add('selected');
    
    // ========== 名字样式控制 ==========
    // 字体大小
    const nameSize = document.getElementById('name-size');
    const nameSizeValue = document.getElementById('name-size-value');
    if (nameSize) {
      nameSize.addEventListener('input', (e) => {
        this.customization.nameSize = parseInt(e.target.value);
        if (nameSizeValue) nameSizeValue.textContent = e.target.value + 'px';
        this.drawPreview();
      });
    }
    
    // 位置Y
    const namePosY = document.getElementById('name-position-y');
    const namePosYValue = document.getElementById('name-position-y-value');
    if (namePosY) {
      namePosY.addEventListener('input', (e) => {
        this.customization.namePositionY = parseInt(e.target.value);
        if (namePosYValue) namePosYValue.textContent = e.target.value;
        this.drawPreview();
      });
    }

    // 名字位置X
    const namePosX = document.getElementById('name-position-x');
    const namePosXValue = document.getElementById('name-position-x-value');
    if (namePosX) {
      namePosX.addEventListener('input', (e) => {
        this.customization.namePositionX = parseInt(e.target.value);
        if (namePosXValue) namePosXValue.textContent = e.target.value;
        this.drawPreview();
      });
    }
    
    // 弧形
    const nameCurve = document.getElementById('name-curve');
    const nameCurveValue = document.getElementById('name-curve-value');
    if (nameCurve) {
      nameCurve.addEventListener('input', (e) => {
        this.customization.nameCurve = parseInt(e.target.value);
        if (nameCurveValue) nameCurveValue.textContent = e.target.value;
        this.drawPreview();
      });
    }
    
    // 字体
    const nameFont = document.getElementById('name-font');
    if (nameFont) {
      // 初始化字体预览
      this.updateFontPreview(nameFont);
      
      nameFont.addEventListener('change', (e) => {
        this.customization.nameFont = e.target.value;
        this.updateFontPreview(nameFont);
        this.drawPreview();
      });
    }
    
    // 填充颜色
    const nameFillColors = document.querySelectorAll('#name-fill-colors .mini-color-swatch');
    nameFillColors.forEach(swatch => {
      swatch.addEventListener('click', () => {
        nameFillColors.forEach(s => s.classList.remove('selected'));
        swatch.classList.add('selected');
        this.customization.nameFillColor = swatch.dataset.color;
        this.drawPreview();
      });
    });
    const defaultNameFill = Array.from(nameFillColors).find(s => s.dataset.color === '#FFFFFF');
    if (defaultNameFill) defaultNameFill.classList.add('selected');
    
    // 描边颜色
    const nameStrokeColors = document.querySelectorAll('#name-stroke-colors .mini-color-swatch');
    nameStrokeColors.forEach(swatch => {
      swatch.addEventListener('click', () => {
        nameStrokeColors.forEach(s => s.classList.remove('selected'));
        swatch.classList.add('selected');
        this.customization.nameStrokeColor = swatch.dataset.color;
        this.drawPreview();
      });
    });
    const defaultNameStroke = Array.from(nameStrokeColors).find(s => s.dataset.color === '#E31837');
    if (defaultNameStroke) defaultNameStroke.classList.add('selected');

    // Team Order 相关事件监听器
    this.setupTeamOrderListeners();
  }

  setupTeamOrderListeners() {
    const addPlayerBtn = document.getElementById('add-player-btn');
    if (addPlayerBtn) {
      addPlayerBtn.addEventListener('click', () => {
        this.addPlayer();
      });
    }
  }

  addPlayer() {
    const playerIndex = this.teamPlayers.length;
    const player = {
      id: Date.now(),
      index: playerIndex + 1,
      size: '',
      playerName: '',
      playerNumber: ''
    };
    
    this.teamPlayers.push(player);
    this.renderPlayersList();
    this.updateTeamOrderSummary();
    this.updatePricing();
  }

  removePlayer(playerId) {
    const index = this.teamPlayers.findIndex(p => p.id === playerId);
    if (index > -1) {
      this.teamPlayers.splice(index, 1);
      // 重新编号
      this.teamPlayers.forEach((p, idx) => {
        p.index = idx + 1;
      });
      this.renderPlayersList();
      this.updateTeamOrderSummary();
      this.updatePricing();
    }
  }

  renderPlayersList() {
    const container = document.getElementById('team-players-list');
    if (!container) return;

    // 团队模式提示
    const teamModeNotice = document.getElementById('team-mode-notice');

    if (this.teamPlayers.length === 0) {
      container.innerHTML = '<p style="text-align: center; color: #999; padding: 20px; font-size: 13px;">No players added yet. Click "+ Add Player" to start your team order.</p>';
      this.isTeamOrder = false;
      // 显示单件订单的尺寸和数量选择
      const singleOrderSize = document.getElementById('single-order-size');
      const singleOrderQuantity = document.getElementById('single-order-quantity');
      if (singleOrderSize) singleOrderSize.style.display = 'block';
      if (singleOrderQuantity) singleOrderQuantity.style.display = 'block';
      // 隐藏团队模式提示
      if (teamModeNotice) teamModeNotice.style.display = 'none';
      return;
    }

    this.isTeamOrder = true;
    // 隐藏单件订单的尺寸和数量选择
    const singleOrderSize = document.getElementById('single-order-size');
    const singleOrderQuantity = document.getElementById('single-order-quantity');
    if (singleOrderSize) singleOrderSize.style.display = 'none';
    if (singleOrderQuantity) singleOrderQuantity.style.display = 'none';
    // 显示团队模式提示
    if (teamModeNotice) teamModeNotice.style.display = 'block';

    container.innerHTML = this.teamPlayers.map(player => `
      <div class="player-item" data-player-id="${player.id}">
        <div class="player-header">
          <span class="player-number-badge">Player ${player.index}</span>
          <button type="button" class="remove-player-btn" data-player-id="${player.id}">
            Remove
          </button>
        </div>
        <div class="player-fields">
          <div class="player-field">
            <label>Size</label>
            <select class="player-size" data-player-id="${player.id}" required>
              <option value="">Select</option>
              ${this.getSizeOptions(player.size)}
            </select>
          </div>
          <div class="player-field">
            <label>Player Name</label>
            <input 
              type="text" 
              class="player-name-input" 
              data-player-id="${player.id}"
              value="${player.playerName}" 
              placeholder="Enter name"
              maxlength="15"
              required>
          </div>
          <div class="player-field">
            <label>Number</label>
            <input 
              type="text" 
              class="player-number-input" 
              data-player-id="${player.id}"
              value="${player.playerNumber}" 
              placeholder="00"
              maxlength="3"
              pattern="[0-9]*"
              required>
          </div>
        </div>
      </div>
    `).join('');

    // 添加事件监听器
    container.querySelectorAll('.remove-player-btn').forEach(btn => {
      btn.addEventListener('click', (e) => {
        const playerId = parseInt(e.target.dataset.playerId);
        this.removePlayer(playerId);
      });
    });

    container.querySelectorAll('.player-size').forEach(select => {
      select.addEventListener('change', (e) => {
        const playerId = parseInt(e.target.dataset.playerId);
        const player = this.teamPlayers.find(p => p.id === playerId);
        if (player) {
          player.size = e.target.value;
          this.updatePricing();
        }
      });
    });

    container.querySelectorAll('.player-name-input').forEach(input => {
      input.addEventListener('input', (e) => {
        const playerId = parseInt(e.target.dataset.playerId);
        const player = this.teamPlayers.find(p => p.id === playerId);
        if (player) {
          player.playerName = e.target.value;
        }
      });
    });

    container.querySelectorAll('.player-number-input').forEach(input => {
      input.addEventListener('input', (e) => {
        e.target.value = e.target.value.replace(/[^0-9]/g, '');
        const playerId = parseInt(e.target.dataset.playerId);
        const player = this.teamPlayers.find(p => p.id === playerId);
        if (player) {
          player.playerNumber = e.target.value;
        }
      });
    });
  }

  getSizeOptions(selectedSize) {
    const sizes = ['XS', 'S', 'M', 'L', 'XL', 'XXL', 'XXXL'];
    return sizes.map(size => 
      `<option value="${size}" ${size === selectedSize ? 'selected' : ''}>${size}</option>`
    ).join('');
  }

  updateTeamOrderSummary() {
    const totalCount = document.getElementById('total-players-count');
    const discountSpan = document.getElementById('team-discount');
    
    if (totalCount) {
      totalCount.textContent = this.teamPlayers.length;
    }
    
    if (discountSpan) {
      const discount = this.teamPlayers.length >= 10 ? 20 : 0;
      discountSpan.textContent = discount + '%';
      discountSpan.style.color = discount > 0 ? '#4caf50' : '#999';
    }
  }
  
  drawInitialPreview() {
    this.drawPreview();
  }
  
  drawPreview() {
    const ctx = this.ctx;
    const canvas = this.canvas;
    
    // 清空画布
    ctx.clearRect(0, 0, canvas.width, canvas.height);
    
    // 应用缩放
    ctx.save();
    ctx.scale(this.zoomLevel, this.zoomLevel);
    
    const centerX = canvas.width / 2 / this.zoomLevel;
    const centerY = canvas.height / 2 / this.zoomLevel;
    
    // 获取当前视图的模板图片
    const template = this.currentView === 'front' ? this.templateImages.front : this.templateImages.back;
    const trim = this.currentView === 'front' ? this.trimImages.front : this.trimImages.back;
    
    if (template) {
      // 使用真实的SVG/PNG模板
      this.drawTemplateImage(ctx, template, centerX, centerY);
      
      // 绘制装饰层（如果有）
      if (trim) {
        this.drawTrimLayer(ctx, trim, centerX, centerY);
      }
    } else {
      // 回退到绘制轮廓
      this.drawDressOutline(ctx, centerX, centerY);
      this.drawDecorations(ctx, centerX, centerY);
    }
    
    // 绘制Logo（如果有）
    if (this.customization.logoImage) {
      this.drawLogo(ctx, centerX, centerY);
    }
    
    // 根据当前视图绘制号码和文字
    if (this.currentView === 'front') {
      // 前视图：队名、前面号码，以及（按用户要求）显示 Player Name 和 Player Number (Back)
      if (this.customization.teamName) {
        this.drawTeamName(ctx, centerX, centerY);
      }
      if (this.customization.playerNumberFront) {
        console.log('Drawing front number:', this.customization.playerNumberFront);
        this.drawNumber(ctx, centerX, centerY, 'front');
      }

      // 将 Player Name 显示在前视图（使用和背面相同的偏移），如果有
      if (this.customization.playerName) {
        this.drawPlayerName(ctx, centerX, centerY, 'front');
      }

      // 将 Player Number (Back) 也显示在前视图（保留其背面样式/位置），如果有
      if (this.customization.playerNumberBack) {
        this.drawNumber(ctx, centerX, centerY, 'back');
      }

      // (back name rendering on front view removed — keep front-only rendering)
    } else {
      // 背视图：在背面绘制 Player Name 和 Player Number (Back)
      // 保持与前视图类似的逻辑，但仅绘制背面应显示的元素
      if (this.customization.playerNumberBack) {
        this.drawNumber(ctx, centerX, centerY, 'back');
      }

      if (this.customization.playerName) {
        this.drawPlayerName(ctx, centerX, centerY, 'back');
      }
    }
    
    ctx.restore();
  }
  
  drawTemplateImage(ctx, image, x, y) {
    // 计算图片绘制尺寸，保持比例
    const maxWidth = 400;
    const maxHeight = 600;
    let width = image.naturalWidth || image.width;
    let height = image.naturalHeight || image.height;
    
    console.log('Drawing main template - Original size:', width, 'x', height);
    
    // 缩放以适应canvas
    const scale = Math.min(maxWidth / width, maxHeight / height);
    width *= scale;
    height *= scale;
    
    console.log('Drawing main template - Scaled size:', width, 'x', height);
    
    const drawX = x - width / 2;
    const drawY = y - height / 2;
    
    try {
      // 使用临时canvas进行合成
      const tempCanvas = document.createElement('canvas');
      tempCanvas.width = width;
      tempCanvas.height = height;
      const tempCtx = tempCanvas.getContext('2d');
      
      // 步骤1: 在临时canvas上画SVG
      tempCtx.drawImage(image, 0, 0, width, height);
      console.log('✓ Main body SVG drawn on temp canvas');
      
      // 步骤2: 用primary color着色（source-atop只给已有像素着色）
      if (this.customization.primaryColor) {
        tempCtx.globalCompositeOperation = 'source-atop';
        tempCtx.fillStyle = this.customization.primaryColor;
        tempCtx.fillRect(0, 0, width, height);
        console.log('✓ PRIMARY color applied:', this.customization.primaryColor);
      }
      
      // 步骤3: 将着色后的结果画到主canvas
      ctx.drawImage(tempCanvas, drawX, drawY);
      console.log('✓ Main body rendered at:', drawX, drawY);
      
    } catch (e) {
      console.error('Error drawing main template:', e);
    }
  }

  // --- Canvas dragging support for position X/Y ---
  enableCanvasDragging() {
    this.dragState = { dragging: false, element: null, startMouse: { x: 0, y: 0 }, startPos: { x: 0, y: 0 } };

    const canvas = this.canvas;
    if (!canvas) return;

    const getMouse = (e) => {
      const rect = canvas.getBoundingClientRect();
      const mx = (e.clientX - rect.left) / this.zoomLevel;
      const my = (e.clientY - rect.top) / this.zoomLevel;
      return { x: mx, y: my };
    };

    const center = () => ({
      x: canvas.width / 2 / this.zoomLevel,
      y: canvas.height / 2 / this.zoomLevel
    });

    const hitTest = (mx, my) => {
      // check elements in priority order (front number, back number, player name, team name)
      const c = center();
      const ctx = this.ctx;

      const checkText = (text, fontSpec, posX, posY) => {
        if (!text) return false;
        ctx.save(); ctx.font = fontSpec;
        const w = ctx.measureText(text).width;
        ctx.restore();
        const h = parseInt((/\d+/.exec(fontSpec) || [16])[0], 10) || 16;
        const left = posX - w / 2;
        const right = posX + w / 2;
        const top = posY - h / 2;
        const bottom = posY + h / 2;
        return mx >= left && mx <= right && my >= top && my <= bottom;
      };

      // front number
      if (this.customization.playerNumberFront) {
        const posX = c.x + (this.customization.numberFrontPositionX || 0);
        const posY = c.y + (this.customization.numberFrontPositionY || 0);
        const font = `bold ${this.customization.numberFrontSize}px ${this.customization.numberFrontFont}`;
        if (checkText(this.customization.playerNumberFront, font, posX, posY)) return { element: 'numberFront' };
      }

      // back number (may be drawn on front view per current behavior)
      if (this.customization.playerNumberBack) {
        const posX = c.x + (this.customization.numberBackPositionX || 0);
        const posY = c.y + (this.customization.numberBackPositionY || 0);
        const font = `bold ${this.customization.numberBackSize}px ${this.customization.numberBackFont}`;
        if (checkText(this.customization.playerNumberBack, font, posX, posY)) return { element: 'numberBack' };
      }

      // player name (use view-specific positions)
      if (this.customization.playerName) {
        const npX = this.currentView === 'front' ? (this.customization.nameFrontPositionX || this.customization.namePositionX || 0) : (this.customization.nameBackPositionX || this.customization.namePositionX || 0);
        const npY = this.currentView === 'front' ? (this.customization.nameFrontPositionY || this.customization.namePositionY || 0) : (this.customization.nameBackPositionY || this.customization.namePositionY || 0);
        const posX = c.x + npX;
        const posY = c.y + npY;
        const font = `bold ${this.customization.nameSize}px ${this.customization.nameFont}`;
        if (checkText(this.customization.playerName, font, posX, posY)) return { element: 'playerName' };
      }

      // team name
      if (this.customization.teamName) {
        const posX = c.x + (this.customization.teamPositionX || 0);
        const posY = c.y + (this.customization.teamPositionY || 0);
        const font = `bold ${this.customization.teamSize}px ${this.customization.teamFont}`;
        if (checkText(this.customization.teamName, font, posX, posY)) return { element: 'teamName' };
      }

      // logo - 确保碰撞检测完全覆盖图片绘制区域
      if (this.customization.logoImage) {
        const baseSize = 80;
        const scale = this.customization.logoScale || 1.0;
        const logoWidth = baseSize * scale;
        const logoHeight = baseSize * scale;
        const posX = c.x + (this.customization.logoPositionX || 0);
        const posY = c.y + (this.customization.logoPositionY || -100);
        // 碰撞检测区域完全匹配图片实际绘制区域
        const left = posX - logoWidth / 2;
        const right = posX + logoWidth / 2;
        const top = posY - logoHeight / 2;
        const bottom = posY + logoHeight / 2;
        if (mx >= left && mx <= right && my >= top && my <= bottom) return { element: 'logo' };
      }

      return null;
    };

    canvas.addEventListener('mousedown', (e) => {
      const m = getMouse(e);
      const hit = hitTest(m.x, m.y);
      if (hit) {
        this.dragState.dragging = true;
        this.dragState.element = hit.element;
        this.dragState.startMouse = { x: m.x, y: m.y };
        // store start offsets
        if (hit.element === 'teamName') this.dragState.startPos.x = this.customization.teamPositionX || 0, this.dragState.startPos.y = this.customization.teamPositionY || 0;
        if (hit.element === 'playerName') {
          if (this.currentView === 'front') {
            this.dragState.startPos.x = this.customization.nameFrontPositionX || this.customization.namePositionX || 0;
            this.dragState.startPos.y = this.customization.nameFrontPositionY || this.customization.namePositionY || 0;
          } else {
            this.dragState.startPos.x = this.customization.nameBackPositionX || this.customization.namePositionX || 0;
            this.dragState.startPos.y = this.customization.nameBackPositionY || this.customization.namePositionY || 0;
          }
        }
        if (hit.element === 'numberFront') this.dragState.startPos.x = this.customization.numberFrontPositionX || 0, this.dragState.startPos.y = this.customization.numberFrontPositionY || 0;
        if (hit.element === 'numberBack') this.dragState.startPos.x = this.customization.numberBackPositionX || 0, this.dragState.startPos.y = this.customization.numberBackPositionY || 0;
        if (hit.element === 'logo') this.dragState.startPos.x = this.customization.logoPositionX || 0, this.dragState.startPos.y = this.customization.logoPositionY || -100;
        canvas.style.cursor = 'grabbing';
      }
    });

    window.addEventListener('mousemove', (e) => {
      const m = getMouse(e);
      if (this.dragState.dragging && this.dragState.element) {
        const dx = m.x - this.dragState.startMouse.x;
        const dy = m.y - this.dragState.startMouse.y;
        const el = this.dragState.element;
        if (el === 'teamName') {
          this.customization.teamPositionX = Math.round(this.dragState.startPos.x + dx);
          this.customization.teamPositionY = Math.round(this.dragState.startPos.y + dy);
        } else if (el === 'playerName') {
          const newX = Math.round(this.dragState.startPos.x + dx);
          const newY = Math.round(this.dragState.startPos.y + dy);
          if (this.currentView === 'front') {
            this.customization.nameFrontPositionX = newX;
            this.customization.nameFrontPositionY = newY;
          } else {
            this.customization.nameBackPositionX = newX;
            this.customization.nameBackPositionY = newY;
          }
          // keep legacy values in sync
          this.customization.namePositionX = newX;
          this.customization.namePositionY = newY;
        } else if (el === 'numberFront') {
          this.customization.numberFrontPositionX = Math.round(this.dragState.startPos.x + dx);
          this.customization.numberFrontPositionY = Math.round(this.dragState.startPos.y + dy);
        } else if (el === 'numberBack') {
          this.customization.numberBackPositionX = Math.round(this.dragState.startPos.x + dx);
          this.customization.numberBackPositionY = Math.round(this.dragState.startPos.y + dy);
        } else if (el === 'logo') {
          this.customization.logoPositionX = Math.round(this.dragState.startPos.x + dx);
          this.customization.logoPositionY = Math.round(this.dragState.startPos.y + dy);
        }
        this.drawPreview();
      } else {
        // cursor feedback when hovering
        const hit = hitTest(m.x, m.y);
        canvas.style.cursor = hit ? 'grab' : 'default';
      }
    });

    window.addEventListener('mouseup', () => {
      if (this.dragState.dragging) {
        this.dragState.dragging = false;
        this.dragState.element = null;
        canvas.style.cursor = 'default';
      }
    });
  }
  
  drawTrimLayer(ctx, image, x, y) {
    // 计算图片绘制尺寸（与主模板相同）
    const maxWidth = 400;
    const maxHeight = 600;
    let width = image.naturalWidth || image.width;
    let height = image.naturalHeight || image.height;
    
    console.log('Drawing trim layer - Original size:', width, 'x', height);
    
    // 缩放以适应canvas
    const scale = Math.min(maxWidth / width, maxHeight / height);
    width *= scale;
    height *= scale;
    
    const drawX = x - width / 2;
    const drawY = y - height / 2;
    
    try {
      // 使用临时canvas进行合成
      const tempCanvas = document.createElement('canvas');
      tempCanvas.width = width;
      tempCanvas.height = height;
      const tempCtx = tempCanvas.getContext('2d');
      
      // 步骤1: 在临时canvas上画trim SVG
      tempCtx.drawImage(image, 0, 0, width, height);
      console.log('✓ Trim layer SVG drawn on temp canvas');
      
      // 步骤2: 用secondary color着色（source-atop只给已有像素着色）
      if (this.customization.secondaryColor) {
        tempCtx.globalCompositeOperation = 'source-atop';
        tempCtx.fillStyle = this.customization.secondaryColor;
        tempCtx.fillRect(0, 0, width, height);
        console.log('✓ SECONDARY color applied:', this.customization.secondaryColor);
      }
      
      // 步骤3: 将着色后的trim层画到主canvas
      ctx.drawImage(tempCanvas, drawX, drawY);
      console.log('✓ Trim layer rendered at:', drawX, drawY);
      
    } catch (e) {
      console.error('Error drawing trim layer:', e);
    }
  }
  
  drawDressOutline(ctx, x, y) {
    const primaryColor = this.customization.primaryColor;
    const secondaryColor = this.customization.secondaryColor;
    
    // 绘制主体
    ctx.fillStyle = primaryColor;
    ctx.beginPath();
    
    if (this.currentView === 'front') {
      // 前视图 - 球衣裙子形状
      // 肩部
      ctx.moveTo(x - 100, y - 150);
      ctx.lineTo(x - 120, y - 130);
      ctx.lineTo(x - 100, y - 100);
      
      // 左侧身
      ctx.lineTo(x - 100, y + 50);
      
      // 裙摆
      ctx.lineTo(x - 130, y + 200);
      ctx.lineTo(x + 130, y + 200);
      
      // 右侧身
      ctx.lineTo(x + 100, y + 50);
      ctx.lineTo(x + 100, y - 100);
      
      // 右肩
      ctx.lineTo(x + 120, y - 130);
      ctx.lineTo(x + 100, y - 150);
      
      // 领口
      ctx.quadraticCurveTo(x, y - 160, x - 100, y - 150);
      
    } else {
      // 背视图
      ctx.moveTo(x - 100, y - 150);
      ctx.lineTo(x - 120, y - 130);
      ctx.lineTo(x - 100, y - 100);
      ctx.lineTo(x - 100, y + 50);
      ctx.lineTo(x - 130, y + 200);
      ctx.lineTo(x + 130, y + 200);
      ctx.lineTo(x + 100, y + 50);
      ctx.lineTo(x + 100, y - 100);
      ctx.lineTo(x + 120, y - 130);
      ctx.lineTo(x + 100, y - 150);
      ctx.quadraticCurveTo(x, y - 160, x - 100, y - 150);
    }
    
    ctx.closePath();
    ctx.fill();
    
    // 绘制边框
    ctx.strokeStyle = secondaryColor;
    ctx.lineWidth = 3;
    ctx.stroke();
    
    // 绘制侧边装饰条
    ctx.fillStyle = secondaryColor;
    ctx.fillRect(x - 95, y - 140, 10, 340);
    ctx.fillRect(x + 85, y - 140, 10, 340);
    
    // 绘制领口装饰
    ctx.beginPath();
    ctx.arc(x, y - 145, 25, 0, Math.PI * 2);
    ctx.fillStyle = secondaryColor;
    ctx.fill();
    
    ctx.beginPath();
    ctx.arc(x, y - 145, 20, 0, Math.PI * 2);
    ctx.fillStyle = primaryColor;
    ctx.fill();
  }
  
  drawDecorations(ctx, x, y) {
    const secondaryColor = this.customization.secondaryColor;
    
    // 绘制腰部装饰线
    ctx.strokeStyle = secondaryColor;
    ctx.lineWidth = 2;
    ctx.beginPath();
    ctx.moveTo(x - 100, y + 50);
    ctx.lineTo(x + 100, y + 50);
    ctx.stroke();
  }
  
  drawLogo(ctx, x, y) {
    const logo = this.customization.logoImage;
    if (!logo) return;
    
    const baseSize = 80; // 基础大小
    const scale = this.customization.logoScale || 1.0;
    const logoWidth = baseSize * scale;
    const logoHeight = baseSize * scale;
    
    const posX = x + (this.customization.logoPositionX || 0);
    const posY = y + (this.customization.logoPositionY || -100);
    
    // 直接绘制logo，不添加圆形裁剪和白色背景
    ctx.save();
    ctx.drawImage(logo, posX - logoWidth / 2, posY - logoHeight / 2, logoWidth, logoHeight);
    ctx.restore();
  }
  
  drawNumber(ctx, x, y, view) {
    const number = view === 'front' ? this.customization.playerNumberFront : this.customization.playerNumberBack;
    const font = view === 'front' ? this.customization.numberFrontFont : this.customization.numberBackFont;
    const size = view === 'front' ? this.customization.numberFrontSize : this.customization.numberBackSize;
    const fillColor = view === 'front' ? this.customization.numberFrontFillColor : this.customization.numberBackFillColor;
    const strokeColor = view === 'front' ? this.customization.numberFrontStrokeColor : this.customization.numberBackStrokeColor;
    let posX = x + (view === 'front' ? (this.customization.numberFrontPositionX || 0) : (this.customization.numberBackPositionX || 0));
    let posY = y + (view === 'front' ? this.customization.numberFrontPositionY : this.customization.numberBackPositionY);
    const letterSpacing = view === 'front' ? this.customization.numberFrontLetterSpacing : (this.customization.numberBackLetterSpacing || 0);
    const strokeEnabled = view === 'front' ? this.customization.numberFrontStrokeEnabled : (typeof this.customization.numberBackStrokeEnabled !== 'undefined' ? this.customization.numberBackStrokeEnabled : true);
    
    // 设置字体
    ctx.font = `bold ${size}px ${font}`;
    ctx.textAlign = 'center';
    ctx.textBaseline = 'middle';
    ctx.lineJoin = 'round';
    ctx.lineCap = 'round';
    ctx.miterLimit = 2;
    
    if (letterSpacing === 0) {
      // 没有字符间距，使用标准渲染
      // 确保在正常的合成模式下绘制（防止之前的合成模式影响文本可见性）
      ctx.save();
      try {
        ctx.globalCompositeOperation = 'source-over';
        // no draw-time override — back number uses its own `numberBackPositionX/Y` so dragging front won't move it

        if (strokeEnabled) {
          ctx.strokeStyle = strokeColor;
          ctx.lineWidth = Math.max(6, size * 0.06);
          ctx.strokeText(number, posX, posY);
        }

        ctx.fillStyle = fillColor;
        ctx.fillText(number, posX, posY);
      } finally {
        ctx.restore();
      }
    } else {
      // 有字符间距，逐个字符绘制
      const chars = number.split('');
      
      // 计算总宽度
      let totalWidth = 0;
      chars.forEach(char => {
        totalWidth += ctx.measureText(char).width;
      });
      totalWidth += letterSpacing * (chars.length - 1);
      
      // 起始位置（居中）
      let currentX = posX - totalWidth / 2;
      
      chars.forEach(char => {
        const charWidth = ctx.measureText(char).width;
        const charCenterX = currentX + charWidth / 2;
        
        if (strokeEnabled) {
          ctx.strokeStyle = strokeColor;
          ctx.lineWidth = Math.max(6, size * 0.06);
          ctx.strokeText(char, charCenterX, posY);
        }
        
        ctx.fillStyle = fillColor;
        ctx.fillText(char, charCenterX, posY);
        
        currentX += charWidth + letterSpacing;
      });
    }
  }
  
  drawPlayerName(ctx, x, y, view = this.currentView) {
    const name = this.customization.playerName;
    const posX = x + (view === 'front' ? (this.customization.nameFrontPositionX || this.customization.namePositionX || 0) : (this.customization.nameBackPositionX || this.customization.namePositionX || 0));
    const posY = y + (view === 'front' ? (this.customization.nameFrontPositionY || this.customization.namePositionY || 0) : (this.customization.nameBackPositionY || this.customization.namePositionY || 0));
    const curve = this.customization.nameCurve;

    // drawPlayerName called with view-specific params

    ctx.font = `bold ${this.customization.nameSize}px ${this.customization.nameFont}`;
    ctx.textAlign = 'center';
    ctx.textBaseline = 'middle';
    
    if (curve !== 0) {
      // 弧形文字
      this.drawCurvedText(ctx, name, posX, posY, curve, {
        font: `bold ${this.customization.nameSize}px ${this.customization.nameFont}`,
        fillColor: this.customization.nameFillColor,
        strokeColor: this.customization.nameStrokeColor,
        strokeWidth: Math.max(3, this.customization.nameSize * 0.15)
      });
    } else {
      // 直线文字
      ctx.lineJoin = 'round';
      ctx.lineCap = 'round';
      ctx.miterLimit = 2;
      
      ctx.strokeStyle = this.customization.nameStrokeColor;
      ctx.lineWidth = Math.max(3, this.customization.nameSize * 0.15);
      ctx.strokeText(name, posX, posY);
      
      ctx.fillStyle = this.customization.nameFillColor;
      ctx.fillText(name, posX, posY);
    }
  }
  
  drawTeamName(ctx, x, y) {
    const teamName = this.customization.teamName;
    const posX = x + (this.customization.teamPositionX || 0);
    const posY = y + this.customization.teamPositionY;
    const letterSpacing = this.customization.teamLetterSpacing;
    
    ctx.font = `bold ${this.customization.teamSize}px ${this.customization.teamFont}`;
    ctx.textAlign = 'center';
    ctx.textBaseline = 'middle';
    ctx.lineJoin = 'round';
    ctx.lineCap = 'round';
    ctx.miterLimit = 2;

    // 如果有弧形设置，优先使用弧形渲染（忽略letter spacing）
    if (this.customization.teamCurve && this.customization.teamCurve !== 0) {
      // pass letterSpacing so curved rendering honors spacing
      this.drawCurvedText(ctx, teamName, posX, posY, this.customization.teamCurve, {
        font: `bold ${this.customization.teamSize}px ${this.customization.teamFont}`,
        fillColor: this.customization.teamFillColor,
        strokeColor: this.customization.teamStrokeColor,
        strokeWidth: Math.max(3, this.customization.teamSize * 0.12)
      }, this.customization.teamLetterSpacing || 0);
      return;
    }

    if (letterSpacing === 0) {
      // 没有字符间距，使用标准渲染
      if (this.customization.teamStrokeEnabled) {
        ctx.strokeStyle = this.customization.teamStrokeColor;
        ctx.lineWidth = Math.max(3, this.customization.teamSize * 0.12);
        ctx.strokeText(teamName, posX, posY);
      }
      
      ctx.fillStyle = this.customization.teamFillColor;
      ctx.fillText(teamName, posX, posY);
    } else {
      // 有字符间距，逐个字符绘制
      const chars = teamName.split('');
      
      // 计算总宽度
      let totalWidth = 0;
      chars.forEach(char => {
        totalWidth += ctx.measureText(char).width;
      });
      totalWidth += letterSpacing * (chars.length - 1);
      
      // 起始位置（居中） - 使用已应用的 X 偏移量
      let currentX = posX - totalWidth / 2;
      
      chars.forEach(char => {
        const charWidth = ctx.measureText(char).width;
        const charCenterX = currentX + charWidth / 2;
        
        if (this.customization.teamStrokeEnabled) {
          ctx.strokeStyle = this.customization.teamStrokeColor;
          ctx.lineWidth = Math.max(3, this.customization.teamSize * 0.12);
          ctx.strokeText(char, charCenterX, posY);
        }
        
        ctx.fillStyle = this.customization.teamFillColor;
        ctx.fillText(char, charCenterX, posY);
        
        currentX += charWidth + letterSpacing;
      });
    }
  }
  
  drawCurvedText(ctx, text, x, y, curve, style, letterSpacing = 0) {
    // curve: -100 到 100，负数向下弯曲，正数向上弯曲
    const radius = 500 / (Math.abs(curve) / 50); // 增大半径，减小弯曲程度
    
    ctx.save();
    ctx.font = style.font;
    ctx.textAlign = 'center';
    ctx.textBaseline = 'middle';
    
    // 设置线条样式，避免尖刺
    ctx.lineJoin = 'round';
    ctx.lineCap = 'round';
    ctx.miterLimit = 2;
    
    // 测量文字总宽度（考虑字符间距）
    const chars = text.split('');
    let totalWidth = 0;
    chars.forEach(ch => { totalWidth += ctx.measureText(ch).width; });
    if (letterSpacing && chars.length > 1) totalWidth += letterSpacing * (chars.length - 1);
    // 根据文字宽度和半径计算总角度
    const totalAngle = totalWidth / radius;

    // 计算每个字符
    let currentX = 0;
    
    // 计算起始角度（让文字居中）
    const startAngle = -totalAngle / 2;
    
    // 调整Y偏移量，让正负值都能正确显示
    const yOffset = curve > 0 ? radius : -radius;
    
    chars.forEach((char) => {
      // 测量当前字符宽度
      const charWidth = ctx.measureText(char).width;
      
      // 计算当前字符的中心角度
      const charCenterAngle = startAngle + (currentX + charWidth / 2) / radius;
      
      // 计算字符位置
      const charX = x + Math.sin(charCenterAngle) * radius;
      const charY = y + yOffset - Math.cos(charCenterAngle) * radius;
      
      ctx.save();
      ctx.translate(charX, charY);
      ctx.rotate(charCenterAngle);
      
      // 绘制描边
      ctx.strokeStyle = style.strokeColor;
      ctx.lineWidth = style.strokeWidth;
      ctx.strokeText(char, 0, 0);
      
      // 绘制填充
      ctx.fillStyle = style.fillColor;
      ctx.fillText(char, 0, 0);
      
      ctx.restore();
      
      // 移动到下一个字符位置（考虑间距）
      currentX += charWidth + (letterSpacing || 0);
    });
    
    ctx.restore();
  }
  
  updatePricing() {
    const basePrice = parseFloat(this.pricing.basePrice) || 0;
    let customizationCost = 0;
    
    // 只检查是否上传了Logo，其他定制（文字）不增加费用
    if (this.customization.logoImage) {
      customizationCost += parseFloat(this.pricing.logoUploadFee) || 0;
    }

    let totalPrice;
    let quantity = 1;
    let discount = 0;

    // 如果是团队订单
    if (this.isTeamOrder && this.teamPlayers.length > 0) {
      quantity = this.teamPlayers.length;
      const subtotal = (basePrice + customizationCost) * quantity;
      
      // 10件以上打8折（20% off）
      if (quantity >= 10) {
        discount = 0.2; // 20% discount
        totalPrice = subtotal * (1 - discount);
      } else {
        totalPrice = subtotal;
      }
    } else {
      // 单件订单 - 考虑数量
      quantity = this.singleOrderQuantity;
      const subtotal = (basePrice + customizationCost) * quantity;
      
      // 10件以上打8折（20% off）
      if (quantity >= 10) {
        discount = 0.2; // 20% discount
        totalPrice = subtotal * (1 - discount);
      } else {
        totalPrice = subtotal;
      }
    }
    
    // 更新UI
    const customPriceEl = document.querySelector('.custom-price');
    const totalPriceEl = document.querySelector('.total-price');
    
    if (customPriceEl) {
      if (quantity > 1) {
        customPriceEl.textContent = `${quantity} × $${(basePrice + customizationCost).toFixed(2)}`;
      } else {
        customPriceEl.textContent = `$${customizationCost.toFixed(2)}`;
      }
    }
    
    if (totalPriceEl) {
      if (discount > 0) {
        const originalTotal = (basePrice + customizationCost) * quantity;
        totalPriceEl.innerHTML = `
          <span style="text-decoration: line-through; color: #999; font-size: 16px; margin-right: 8px;">$${originalTotal.toFixed(2)}</span>
          $${totalPrice.toFixed(2)}
        `;
      } else {
        totalPriceEl.textContent = `$${totalPrice.toFixed(2)}`;
      }
    }
  }
  
  async addToCart() {
    const btn = document.getElementById('add-to-cart-builder');
    
    // 如果是团队订单
    if (this.isTeamOrder && this.teamPlayers.length > 0) {
      return this.addTeamOrderToCart(btn);
    }
    
    // 单件订单验证
    if (!this.customization.size) {
      alert('Please select a size');
      return;
    }
    
    if (!this.customization.primaryColor) {
      alert('Please select a primary color');
      return;
    }
    
    // 禁用按钮
    if (btn) {
      btn.disabled = true;
      btn.textContent = 'Adding to Cart...';
    }
    
    try {
      // 生成缩小的预览图 data URL
      let previewDataURL = null;
      try {
        previewDataURL = await this.getPreviewDataURL();
        console.log('Preview data URL generated, length:', previewDataURL.length);
      } catch (previewErr) {
        console.warn('Could not generate preview dataURL, continuing without preview', previewErr);
      }

      // 准备购物车数据
      const variantId = (window.basketballDressBuilderData && window.basketballDressBuilderData.variantId) || this.pricing.variantId || this.pricing.productId;
      const quantity = this.singleOrderQuantity;
      const discount = quantity >= 10 ? 0.2 : 0;

      const properties = {
        'Size': this.customization.size,
        'Primary Color': document.querySelector('.color-picker-grid:not(.secondary-colors) .color-option.selected')?.dataset.name || '',
        'Secondary Color': document.querySelector('.secondary-colors .color-option.selected')?.dataset.name || ''
      };

      // Team Name 及其样式设置
      if (this.customization.teamName) {
        properties['Team Name'] = this.customization.teamName;
        if (this.customization.teamFont && this.customization.teamFont !== 'Impact') {
          properties['Team Name Font'] = this.customization.teamFont;
        }
        if (this.customization.teamSize && this.customization.teamSize !== 34) {
          properties['Team Name Size'] = this.customization.teamSize + 'px';
        }
        if (this.customization.teamLetterSpacing && this.customization.teamLetterSpacing !== 0) {
          properties['Team Name Letter Spacing'] = this.customization.teamLetterSpacing + 'px';
        }
        if (this.customization.teamCurve && this.customization.teamCurve !== 0) {
          properties['Team Name Curve'] = this.customization.teamCurve;
        }
        if (this.customization.teamFillColor && this.customization.teamFillColor !== '#FFFFFF') {
          properties['Team Name Fill Color'] = this.customization.teamFillColor;
        }
        if (this.customization.teamStrokeEnabled && this.customization.teamStrokeColor) {
          properties['Team Name Stroke Color'] = this.customization.teamStrokeColor;
        }
      }

      // Player Number (Front) 及其样式设置
      if (this.customization.playerNumberFront) {
        properties['Player Number (Front)'] = this.customization.playerNumberFront;
        if (this.customization.numberFrontFont && this.customization.numberFrontFont !== 'Impact') {
          properties['Front Number Font'] = this.customization.numberFrontFont;
        }
        if (this.customization.numberFrontSize && this.customization.numberFrontSize !== 80) {
          properties['Front Number Size'] = this.customization.numberFrontSize + 'px';
        }
        if (this.customization.numberFrontLetterSpacing && this.customization.numberFrontLetterSpacing !== 0) {
          properties['Front Number Letter Spacing'] = this.customization.numberFrontLetterSpacing + 'px';
        }
        if (this.customization.numberFrontFillColor && this.customization.numberFrontFillColor !== '#FFFFFF') {
          properties['Front Number Fill Color'] = this.customization.numberFrontFillColor;
        }
        if (this.customization.numberFrontStrokeColor) {
          properties['Front Number Stroke Color'] = this.customization.numberFrontStrokeColor;
        }
      }

      // Player Name 及其样式设置
      if (this.customization.playerName) {
        properties['Player Name'] = this.customization.playerName;
        if (this.customization.nameFont && this.customization.nameFont !== 'Arial') {
          properties['Player Name Font'] = this.customization.nameFont;
        }
        if (this.customization.nameSize && this.customization.nameSize !== 28) {
          properties['Player Name Size'] = this.customization.nameSize + 'px';
        }
        if (this.customization.nameLetterSpacing && this.customization.nameLetterSpacing !== 0) {
          properties['Player Name Letter Spacing'] = this.customization.nameLetterSpacing + 'px';
        }
        if (this.customization.nameCurve && this.customization.nameCurve !== 0) {
          properties['Player Name Curve'] = this.customization.nameCurve;
        }
        if (this.customization.nameFillColor && this.customization.nameFillColor !== '#FFFFFF') {
          properties['Player Name Fill Color'] = this.customization.nameFillColor;
        }
        if (this.customization.nameStrokeColor) {
          properties['Player Name Stroke Color'] = this.customization.nameStrokeColor;
        }
      }

      // Player Number (Back) 及其样式设置
      if (this.customization.playerNumberBack) {
        properties['Player Number (Back)'] = this.customization.playerNumberBack;
        if (this.customization.numberBackFont && this.customization.numberBackFont !== 'Impact') {
          properties['Back Number Font'] = this.customization.numberBackFont;
        }
        if (this.customization.numberBackSize && this.customization.numberBackSize !== 120) {
          properties['Back Number Size'] = this.customization.numberBackSize + 'px';
        }
        if (this.customization.numberBackLetterSpacing && this.customization.numberBackLetterSpacing !== 5) {
          properties['Back Number Letter Spacing'] = this.customization.numberBackLetterSpacing + 'px';
        }
        if (this.customization.numberBackFillColor && this.customization.numberBackFillColor !== '#FFFFFF') {
          properties['Back Number Fill Color'] = this.customization.numberBackFillColor;
        }
        if (this.customization.numberBackStrokeColor) {
          properties['Back Number Stroke Color'] = this.customization.numberBackStrokeColor;
        }
      }

      // Logo 信息
      if (this.customization.logoImage) {
        properties['Custom Logo'] = 'Yes';
        if (this.customization.logoScale && this.customization.logoScale !== 1.0) {
          properties['Logo Scale'] = this.customization.logoScale + 'x';
        }
      }

      // 如果有折扣，添加折扣信息
      if (discount > 0) {
        properties['Discount'] = `${discount * 100}% off`;
      }

      // 将 preview data URL 写入属性
      if (previewDataURL) {
        properties['Preview URL'] = previewDataURL;
      }

      const cartData = { items: [{ id: variantId, quantity: quantity, properties }] };

      console.log('Adding to cart - payload:', cartData);
      
      // 发送到Shopify购物车
      const response = await fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(cartData)
      });

      if (response.ok) {
        const data = await response.json();

        // 尝试调用主题的回调（如果存在）
        if (window.Shopify && window.Shopify.onItemAdded) {
          try { window.Shopify.onItemAdded(); } catch (e) { console.warn('Shopify.onItemAdded failed', e); }
        }

        // 显示成功消息
        this.showSuccessMessage();

        // 请求最新购物车并触发主题的 refreshCart 方法（如果可用），以实时更新 mini cart
        try {
          // 如果页面有 jQuery，优先使用主题常用的 $.ajax 流程，确保兼容主题中绑定的回调
          if (window && window.jQuery && typeof $.ajax === 'function') {
            try {
              $.ajax({
                url: '/cart.js',
                dataType: 'json',
                cache: false,
                success: function(cart) {
                  try {
                    if (typeof refreshCart === 'function') {
                      // 小延迟以兼容主题动画/处理
                      setTimeout(function(){ try { refreshCart(cart); } catch(e){ console.warn('refreshCart failed', e); } }, 300);
                    }
                  } catch(e) { console.warn('refreshCart flow failed', e); }
                }
              });
            } catch (e) {
              console.warn('jQuery ajax to /cart.js failed', e);
            }
          } else {
            // 无 jQuery 时使用 fetch 并在成功后调用 refreshCart（如在全局可用）
            const cartResp = await fetch('/cart.js');
            if (cartResp.ok) {
              const cartJson = await cartResp.json();
              // 支持两种全局方式调用 refreshCart
              if (typeof window.refreshCart === 'function') {
                setTimeout(function(){ try { window.refreshCart(cartJson); } catch(e){ console.warn('window.refreshCart failed', e); } }, 300);
              } else if (typeof refreshCart === 'function') {
                setTimeout(function(){ try { refreshCart(cartJson); } catch(e){ console.warn('refreshCart failed', e); } }, 300);
              }
            }
          }
        } catch (err) {
          console.warn('Failed to fetch /cart.js to refresh mini cart:', err);
        }

        // 可选：跳转到购物车
        // window.location.href = '/cart';
      } else {
        // 尝试读取响应中的错误信息以便诊断
        let errText = '';
        try {
          const errJson = await response.json();
          errText = errJson && (errJson.description || errJson.message || JSON.stringify(errJson));
        } catch (parseErr) {
          errText = await response.text();
        }
        throw new Error(`Failed to add to cart: ${errText}`);
      }
      
    } catch (error) {
      console.error('Error adding to cart:', error);
      alert('There was an error adding the item to your cart. Please try again.');
    } finally {
      // 重新启用按钮
      if (btn) {
        btn.disabled = false;
        btn.innerHTML = `
          <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
            <path d="M3 3H5L5.4 5M7 13H15L17 5H5.4M7 13L5.4 5M7 13L5.34315 14.6569C4.84344 15.1566 5.19469 16 5.87868 16H15M15 16C14.4477 16 14 16.4477 14 17C14 17.5523 14.4477 18 15 18C15.5523 18 16 17.5523 16 17C16 16.4477 15.5523 16 15 16ZM9 17C9 17.5523 8.55228 18 8 18C7.44772 18 7 17.5523 7 17C7 16.4477 7.44772 16 8 16C8.55228 16 9 16.4477 9 17Z" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
          Add to Cart
        `;
      }
    }
  }
  
  getPreviewDataURL() {
    return new Promise((resolve) => {
      // 创建临时canvas用于导出并缩小尺寸以避免上传过大的base64字符串
      const maxWidth = 300;
      const maxHeight = 400;
      const tempCanvas = document.createElement('canvas');

      // 计算缩放比例以保持宽高比
      const scaleX = maxWidth / this.canvas.width;
      const scaleY = maxHeight / this.canvas.height;
      const scale = Math.min(scaleX, scaleY, 1);

      tempCanvas.width = Math.round(this.canvas.width * scale);
      tempCanvas.height = Math.round(this.canvas.height * scale);
      const tempCtx = tempCanvas.getContext('2d');

      // 使用 drawImage 缩放复制当前预览
      tempCtx.drawImage(this.canvas, 0, 0, tempCanvas.width, tempCanvas.height);

      // 导出为 JPEG（体积更小），质量 0.7
      resolve(tempCanvas.toDataURL('image/jpeg', 0.7));
    });
  }

  dataURLToBlob(dataURL) {
    const parts = dataURL.split(',');
    const meta = parts[0];
    const base64 = parts[1];
    const mimeMatch = meta.match(/:(.*?);/);
    const mime = mimeMatch ? mimeMatch[1] : 'image/jpeg';
    const binary = atob(base64);
    const len = binary.length;
    const u8 = new Uint8Array(len);
    for (let i = 0; i < len; i++) u8[i] = binary.charCodeAt(i);
    return new Blob([u8], { type: mime });
  }

  async uploadPreview(dataURL) {
    // 上传到外部 endpoint（由 Liquid 在 window.basketballDressBuilderData.uploadEndpoint 提供）
    const endpoint = window.basketballDressBuilderData && window.basketballDressBuilderData.uploadEndpoint;
    if (!endpoint) throw new Error('No upload endpoint configured');

    const blob = this.dataURLToBlob(dataURL);
    const form = new FormData();
    form.append('file', blob, 'preview.jpg');

    const resp = await fetch(endpoint, { method: 'POST', body: form });
    if (!resp.ok) {
      const txt = await resp.text();
      throw new Error(`Upload failed: ${resp.status} ${txt}`);
    }

    const json = await resp.json();
    // 支持多种字段名返回（url / fileUrl / location / secure_url）
    return json.url || json.fileUrl || json.location || json.secure_url || json.link || null;
  }

  async addTeamOrderToCart(btn) {
    // 验证团队订单
    if (this.teamPlayers.length === 0) {
      alert('Please add at least one player to your team order');
      return;
    }

    // 验证每个球员的必填项
    for (let i = 0; i < this.teamPlayers.length; i++) {
      const player = this.teamPlayers[i];
      if (!player.size) {
        alert(`Please select size for Player ${player.index}`);
        return;
      }
      if (!player.playerName) {
        alert(`Please enter player name for Player ${player.index}`);
        return;
      }
      if (!player.playerNumber) {
        alert(`Please enter player number for Player ${player.index}`);
        return;
      }
    }

    if (!this.customization.primaryColor) {
      alert('Please select a primary color');
      return;
    }

    // 禁用按钮
    if (btn) {
      btn.disabled = true;
      btn.textContent = 'Adding Team Order...';
    }

    try {
      const variantId = (window.basketballDressBuilderData && window.basketballDressBuilderData.variantId) || this.pricing.variantId || this.pricing.productId;
      const basePrice = parseFloat(this.pricing.basePrice) || 0;
      const logoFee = this.customization.logoImage ? (parseFloat(this.pricing.logoUploadFee) || 0) : 0;
      const quantity = this.teamPlayers.length;
      const discount = quantity >= 10 ? 0.2 : 0;

      // 为每个球员创建一个购物车项目
      const items = [];
      
      for (const player of this.teamPlayers) {
        // 生成预览图 - 暂时使用通用定制生成单个预览
        let previewDataURL = null;
        try {
          // 临时将当前球员的信息设置到customization中生成预览
          const tempPlayerName = this.customization.playerName;
          const tempPlayerNumberBack = this.customization.playerNumberBack;
          
          this.customization.playerName = player.playerName;
          this.customization.playerNumberBack = player.playerNumber;
          this.drawPreview();
          
          previewDataURL = await this.getPreviewDataURL();
          
          // 恢复原始值
          this.customization.playerName = tempPlayerName;
          this.customization.playerNumberBack = tempPlayerNumberBack;
          this.drawPreview();
        } catch (previewErr) {
          console.warn('Could not generate preview for player', player.index, previewErr);
        }

        const properties = {
          'Size': player.size,
          'Player Name': player.playerName,
          'Player Number': player.playerNumber,
          'Primary Color': document.querySelector('.color-picker-grid:not(.secondary-colors) .color-option.selected')?.dataset.name || '',
          'Secondary Color': document.querySelector('.secondary-colors .color-option.selected')?.dataset.name || '',
          'Team Order': `Player ${player.index} of ${quantity}`
        };

        // Team Name 及其样式设置
        if (this.customization.teamName) {
          properties['Team Name'] = this.customization.teamName;
          if (this.customization.teamFont && this.customization.teamFont !== 'Impact') {
            properties['Team Name Font'] = this.customization.teamFont;
          }
          if (this.customization.teamSize && this.customization.teamSize !== 34) {
            properties['Team Name Size'] = this.customization.teamSize + 'px';
          }
          if (this.customization.teamLetterSpacing && this.customization.teamLetterSpacing !== 0) {
            properties['Team Name Letter Spacing'] = this.customization.teamLetterSpacing + 'px';
          }
          if (this.customization.teamCurve && this.customization.teamCurve !== 0) {
            properties['Team Name Curve'] = this.customization.teamCurve;
          }
          if (this.customization.teamFillColor && this.customization.teamFillColor !== '#FFFFFF') {
            properties['Team Name Fill Color'] = this.customization.teamFillColor;
          }
          if (this.customization.teamStrokeEnabled && this.customization.teamStrokeColor) {
            properties['Team Name Stroke Color'] = this.customization.teamStrokeColor;
          }
        }

        // Player Number (Front) 样式设置
        if (this.customization.playerNumberFront) {
          properties['Player Number (Front)'] = this.customization.playerNumberFront;
          if (this.customization.numberFrontFont && this.customization.numberFrontFont !== 'Impact') {
            properties['Front Number Font'] = this.customization.numberFrontFont;
          }
          if (this.customization.numberFrontSize && this.customization.numberFrontSize !== 80) {
            properties['Front Number Size'] = this.customization.numberFrontSize + 'px';
          }
          if (this.customization.numberFrontLetterSpacing && this.customization.numberFrontLetterSpacing !== 0) {
            properties['Front Number Letter Spacing'] = this.customization.numberFrontLetterSpacing + 'px';
          }
          if (this.customization.numberFrontFillColor && this.customization.numberFrontFillColor !== '#FFFFFF') {
            properties['Front Number Fill Color'] = this.customization.numberFrontFillColor;
          }
          if (this.customization.numberFrontStrokeColor) {
            properties['Front Number Stroke Color'] = this.customization.numberFrontStrokeColor;
          }
        }

        // Player Name 样式设置（使用玩家自己的名字）
        if (this.customization.nameFont && this.customization.nameFont !== 'Arial') {
          properties['Player Name Font'] = this.customization.nameFont;
        }
        if (this.customization.nameSize && this.customization.nameSize !== 28) {
          properties['Player Name Size'] = this.customization.nameSize + 'px';
        }
        if (this.customization.nameLetterSpacing && this.customization.nameLetterSpacing !== 0) {
          properties['Player Name Letter Spacing'] = this.customization.nameLetterSpacing + 'px';
        }
        if (this.customization.nameCurve && this.customization.nameCurve !== 0) {
          properties['Player Name Curve'] = this.customization.nameCurve;
        }
        if (this.customization.nameFillColor && this.customization.nameFillColor !== '#FFFFFF') {
          properties['Player Name Fill Color'] = this.customization.nameFillColor;
        }
        if (this.customization.nameStrokeColor) {
          properties['Player Name Stroke Color'] = this.customization.nameStrokeColor;
        }

        // Player Number (Back) 样式设置（使用玩家自己的号码）
        if (this.customization.numberBackFont && this.customization.numberBackFont !== 'Impact') {
          properties['Back Number Font'] = this.customization.numberBackFont;
        }
        if (this.customization.numberBackSize && this.customization.numberBackSize !== 120) {
          properties['Back Number Size'] = this.customization.numberBackSize + 'px';
        }
        if (this.customization.numberBackLetterSpacing && this.customization.numberBackLetterSpacing !== 5) {
          properties['Back Number Letter Spacing'] = this.customization.numberBackLetterSpacing + 'px';
        }
        if (this.customization.numberBackFillColor && this.customization.numberBackFillColor !== '#FFFFFF') {
          properties['Back Number Fill Color'] = this.customization.numberBackFillColor;
        }
        if (this.customization.numberBackStrokeColor) {
          properties['Back Number Stroke Color'] = this.customization.numberBackStrokeColor;
        }

        // Logo 信息
        if (this.customization.logoImage) {
          properties['Custom Logo'] = 'Yes';
          if (this.customization.logoScale && this.customization.logoScale !== 1.0) {
            properties['Logo Scale'] = this.customization.logoScale + 'x';
          }
        }

        // 折扣信息
        if (discount > 0) {
          properties['Discount'] = `${discount * 100}% off`;
        }

        if (previewDataURL) {
          properties['Preview URL'] = previewDataURL;
        }

        items.push({
          id: variantId,
          quantity: 1,
          properties
        });
      }

      console.log('Adding team order to cart - payload:', { items });

      // 批量添加到购物车
      const response = await fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ items })
      });

      if (response.ok) {
        // 显示成功消息
        this.showSuccessMessage(`${quantity} jerseys added to cart successfully!`);

        // 刷新购物车
        try {
          if (window && window.jQuery && typeof $.ajax === 'function') {
            $.ajax({
              url: '/cart.js',
              dataType: 'json',
              cache: false,
              success: function(cart) {
                try {
                  if (typeof refreshCart === 'function') {
                    setTimeout(function(){ refreshCart(cart); }, 300);
                  }
                } catch(e) { console.warn('refreshCart failed', e); }
              }
            });
          } else {
            const cartResp = await fetch('/cart.js');
            if (cartResp.ok) {
              const cart = await cartResp.json();
              if (window.refreshCart) window.refreshCart(cart);
            }
          }
        } catch (e) {
          console.warn('Cart refresh failed', e);
        }

        // 3秒后重定向到购物车
        setTimeout(() => {
          window.location.href = '/cart';
        }, 1500);

      } else {
        throw new Error('Failed to add team order to cart');
      }

    } catch (error) {
      console.error('Error adding team order to cart:', error);
      alert('Error adding team order to cart. Please try again.');
    } finally {
      // 重新启用按钮
      if (btn) {
        btn.disabled = false;
        btn.textContent = 'Add to Cart';
      }
    }
  }
  
  showSuccessMessage(message = 'Added to cart successfully!') {
    // 创建成功提示
    const messageEl = document.createElement('div');
    messageEl.className = 'cart-success-message';
    messageEl.innerHTML = `
      <div class="success-content">
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
          <path d="M9 12L11 14L15 10M21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12Z" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
        <span>${message}</span>
      </div>
    `;
    
    // 添加样式
    const style = document.createElement('style');
    style.textContent = `
      .cart-success-message {
        position: fixed;
        top: 20px;
        right: 20px;
        background: #4CAF50;
        color: white;
        padding: 16px 24px;
        border-radius: 8px;
        box-shadow: 0 4px 12px rgba(0,0,0,0.2);
        z-index: 10000;
        animation: slideIn 0.3s ease-out;
      }
      
      .success-content {
        display: flex;
        align-items: center;
        gap: 12px;
        font-weight: 600;
      }
      
      .success-content svg {
        stroke: white;
      }
      
      @keyframes slideIn {
        from {
          transform: translateX(400px);
          opacity: 0;
        }
        to {
          transform: translateX(0);
          opacity: 1;
        }
      }
    `;
    
    document.head.appendChild(style);
    document.body.appendChild(messageEl);
    
    // 3秒后移除
    setTimeout(() => {
      messageEl.style.animation = 'slideOut 0.3s ease-in';
      setTimeout(() => {
        messageEl.remove();
      }, 300);
    }, 3000);
    
    // 添加slideOut动画
    const slideOutStyle = document.createElement('style');
    slideOutStyle.textContent = `
      @keyframes slideOut {
        from {
          transform: translateX(0);
          opacity: 1;
        }
        to {
          transform: translateX(400px);
          opacity: 0;
        }
      }
    `;
    document.head.appendChild(slideOutStyle);
  }
}

// 初始化
document.addEventListener('DOMContentLoaded', () => {
  console.log('DOMContentLoaded fired');
  console.log('basketballDressBuilderData:', window.basketballDressBuilderData);
  
  const builder = new BasketballDressBuilder();
  console.log('Builder instance created:', builder);
  
  // 将builder实例暴露到全局以便调试
  window.builder = builder;
  
  // 在所有内容加载后，再次初始化字体预览（确保字体已加载）
  if (document.fonts) {
    document.fonts.ready.then(() => {
      console.log('All fonts loaded, re-initializing font previews');
      // 重新初始化所有字体选择器的预览
      const fontSelectors = [
        document.getElementById('team-font'),
        document.getElementById('number-front-font'),
        document.getElementById('number-back-font'),
        document.getElementById('name-font')
      ];
      
      fontSelectors.forEach(selector => {
        if (selector && builder.updateFontPreview) {
          builder.updateFontPreview(selector);
        }
      });
    });
  }
});
